import { action, computed, observable } from 'mobx';
import { AvailableRow } from '~client/model/available-row';
import { AvailableSeat } from '~client/model/available-seat';
import { AvailableSection } from '~client/model/available-section';
import { BaseStore } from '~web/store/base/base-store';

export class SeatsStore extends BaseStore {
  @observable row: AvailableRow;
  @observable seats: AvailableSeat[] = observable.array();
  @observable section: AvailableSection;

  @computed
  get seatCodes(): string[] {
    return this.seats.map((seat) => seat.seatCode);
  }

  @action
  clear(): void {
    this.row = undefined;
    this.seats = observable.array();
    this.section = undefined;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/seating/seats-store.ts